import React from 'react';
import i18next from 'i18next';

export const NoTableData = ({ text = i18next.t('common.placeholders.noDataFound') }: { text?: string }) => (
  <div className="rs-table-body-info">{text}</div>
);
